import React, { useState, useEffect, useCallback, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { handleBet, saveSettings } from "../../redux/actions/postActions";

// region  WS library
import { ScalingContainer } from "../../AppStyled";

// endregion

// region  Pages

import { ProvFair } from "../otherPages/provFair/provFair";
// import WinScreen from "../otherPages/winScreen/winScreen";
import SetBet from "./bet/SetBet/SetBet";
import Settings from "../otherPages/settings/Settings";
import HitsPage from "./hits/HitsPage";

// endregion

// region  Styled and Other Small Components
import { History } from "../otherPages/history/History";
import BetReplay from "../otherPages/betReplay/BetReplay";
import GameRules from "../otherPages/gameRules/GameRules";
import Autorules from "./auto/AutoRules";

import { Header } from "./header/Header";
import Main from "./main/Main";
import Footer from "./footer/Footer";
import { BlurBox } from "./kenoStyled";

import useSound from "use-sound";

import randomSound from "../../audio/random.mp3";

import closeSound from "../../audio/goBack.mp3";
import forwardSound from "../../audio/goForward.mp3";

import keno40background from "../../audio/background40.mp3";
import keno80background from "../../audio/background80.mp3";
import kenoSonicBackground from "../../audio/kenoSonicMusic.mp3";
import { placeBet } from "../../lib/socketMessages";

// endregion

const Keno = ({
  user_id,
  betInfo,
  isAutoOn,
  toggleIsAutoOn,
  showLoading,
  handleSelected,
  clearWonBalls,
  selectedFromApp,
  history,
  handleAutoRollLogic,
  fadeInKeno,
  stats,
  autorollLogic,
  autoConfigs,
  handleNotification,
  gameState,
  toFix,
  currency,
  sound,
  music,
  volume,
  makeClickable,
  handleVolume,
  scrollable,
  intViewportHeight,
  noSignal,
  betReplyData,
  handleBetReply,
}) => {
  const [above, setabove] = useState(false);
  // const [above, setabove] = useState("BetReplay");
  const [showHistory, setshowHistory] = useState(false);
  const [showGameRules, setshowGameRules] = useState(false);
  const [showBetReplay, setshowBetReplay] = useState(false);
  const [randomSFX] = useSound(randomSound, { volume });
  const [closeSFX] = useSound(closeSound, { volume });
  const [forwardSFX] = useSound(forwardSound, { volume });
  const [keno40backgroundSFX, keno40Obj] = useSound(keno40background, {
    volume,
  });
  const [keno80backgroundSFX, keno80Obj] = useSound(keno80background, {
    volume,
  });

  const [kenoSonicBackgroundSFX, sonicObj] = useSound(kenoSonicBackground, {
    volume,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (above === "gameRules") {
      setTimeout(() => {
        setshowGameRules(true);
      }, 100);
    } else {
      setshowGameRules(false);
    }
    if (above === "History") {
      setTimeout(() => {
        setshowHistory(true);
      }, 100);
    } else {
      setshowHistory(false);
    }
    if (above === "betReplay") {
      setTimeout(() => {
        setshowBetReplay(true);
      }, 100);
    } else {
      setshowBetReplay(false);
    }
    

    setdisplaySettings(
      above === "settings",
      // ||
      //   above === "History" ||
      //   above === "provFair" ||
      //   above === "gameRules"
    );
    setdisplayHits(above && above.includes("Hits"));
    setdisplayAutoRules(above === "autorules");
  }, [above, forwardSFX, closeSFX]);
  const [unBlur, setunBlur] = useState(false);
  const [clickable, setclickable] = useState(true);
  useEffect(() => {
    setclickable(true);
  }, [user_id]);

  useEffect(() => {
    if (makeClickable) {
      setclickable(true);
    }
  }, [makeClickable]);

  const st = useSelector(
    (state) => state,
    () => { },
  );
  useEffect(() => {
    if (isAutoOn) {
      setclickable(false);
    }
  }, [isAutoOn]);
  const { userSettings, gameMode, game_settings, bet } = st;
  useEffect(() => {
    if (gameMode === "sonic") {
      music
        ? (() => {
          if (!sonicObj.isPlaying) kenoSonicBackgroundSFX();
        })()
        : sonicObj.stop();
      keno40Obj.stop();
      keno80Obj.stop();
    }
    if (gameMode === "40") {
      music
        ? (() => {
          if (!keno40Obj.isPlaying) keno40backgroundSFX();
        })()
        : keno40Obj.stop();
      sonicObj.stop();
      keno80Obj.stop();
    }
    if (gameMode === "80") {
      music
        ? (() => {
          if (!keno80Obj.isPlaying) keno80backgroundSFX();
        })()
        : keno80Obj.stop();
      sonicObj.stop();
      keno40Obj.stop();
    }
  }, [
    gameMode,
    music,
    kenoSonicBackgroundSFX,
    keno40backgroundSFX,
    keno80backgroundSFX,
    keno40Obj,
    keno80Obj,
    sonicObj,
  ]);
  const ballsq = (q) => {
    let b = [];
    for (let i = 1; i <= q; i++) {
      b.push(i);
    }
    return b;
  };

  const [selected, setselected] = useState(selectedFromApp);
  useEffect(() => {
    setselected(selectedFromApp);
  }, [selectedFromApp]);

  const [balls, setballs] = useState(
    gameMode === "80" ? ballsq(80) : ballsq(40),
  );
  const handleClean = useCallback(() => {
    setselected([]);
    setwonBalls([]);
  }, []);

  const [wonBalls, setwonBalls] = useState([]);

  const handleSelect = useCallback(
    (i) => {
      setwonBalls([]);
      selected.includes(i) || selected.length > 9
        ? setselected((s) => s.filter((s) => s !== i))
        : setselected((s) => [...s, i]);
      if (!selected.includes(i) && selected.length > 9) {
        handleNotification("Can't choose more than 10 balls");
      }
    },
    [selected, handleNotification],
  );
  const random = useCallback(
    (q) => {
      handleClean();
      let a = 40;
      if (typeof q === "number") {
        a = q;
      }
      if (sound) randomSFX();

      let rands = [];

      for (let i = 0; rands.length < 10; i++) {
        let rand = Math.floor(Math.random() * a) + 1;
        if (!rands.includes(rand)) rands.push(rand);
      }
      setselected(rands);
    },
    [handleClean, randomSFX, sound],
  );
  const toggleClickable = useCallback(
    (b) => {
      setclickable((c) => b || !c);
    },
    [setclickable],
  );

  const handlePlay = useCallback(() => {
    const minBet = gameState.minBet
    const betCheck = +bet < minBet ? minBet : bet
    setwonBalls([]);
    dispatch(handleBet(betCheck));
    if (selected.length > 0) {
      toggleClickable(false);
      dispatch(saveSettings(betCheck));
      // Globals.WS.sendMessage(
      //   MessageFactory.createMessage(Protocol.BET, +bet, selected.join(":"))
      // );

      placeBet(+betCheck, selected.join(":"));
    } else {
      handleNotification("Choose at least 1 ball");
    }
  }, [bet, handleNotification, selected, toggleClickable, dispatch, gameState]);

  useEffect(() => {
    setwonBalls(betInfo.numbers);
  }, [betInfo.numbers, toggleClickable, gameMode]);

  useEffect(() => {
    setballs(gameMode === "80" ? ballsq(80) : ballsq(40));
    handleClean();
    clearWonBalls();
    setwonBalls([]);
  }, [gameMode, handleClean, clearWonBalls]);
  const handleAbove = useCallback(
    (a) => {
      handleNotification(false);
      if (!a) {
        setunBlur(true);
        setTimeout(() => {
          setunBlur(false);
          setabove(a);
        }, 400);
      } else {
        setabove(a);
      }
    },
    [handleNotification],
  );

  const sendSelectedToApp = useCallback(
    () => handleSelected(selected),
    [handleSelected, selected],
  );

  const [displaySettings, setdisplaySettings] = useState(false);
  const [displayHits, setdisplayHits] = useState(false);
  const [displayAutoRules, setdisplayAutoRules] = useState(false);
  return (
    <>
      <ScalingContainer className="ScalingContainer" h={intViewportHeight}>
        <BlurBox
          className="BlurBox"
          blur={above}
          unBlur={unBlur}
          fadeInKeno={fadeInKeno}
          showLoading={showLoading}
          onContextMenu={(e) => e.preventDefault()}
        >
          <Header
            betInfo={betInfo}
            handleAbove={handleAbove}
            gameMode={gameMode}
            toFix={toFix}
            volume={volume}
            sound={sound}
            currency={currency}
          />
          <Main
            betInfo={betInfo}
            balls={balls}
            wonBalls={wonBalls}
            gameMode={gameMode}
            isAutoOn={isAutoOn}
            game_settings={game_settings}
            handleSelect={handleSelect}
            selected={selected}
            handleAbove={handleAbove}
            toggleClickable={toggleClickable}
            clickable={clickable}
            toFix={toFix}
            sound={sound}
            volume={volume}
          />
          <Footer
            className="footer"
            betInfo={betInfo}
            isAutoOn={isAutoOn}
            // userSettings={userSettings}
            toggleIsAutoOn={toggleIsAutoOn}
            play={handlePlay}
            random={random}
            handleClean={handleClean}
            handleAbove={handleAbove}
            sendSelectedToApp={sendSelectedToApp}
            n={selected.length}
            clickable={clickable}
            betCount={autorollLogic.numBets}
            betTotal={autoConfigs.numberOfBets}
            handleNotification={handleNotification}
            toFix={toFix}
            minBet={gameState.minBet}
            maxBet={gameState.maxBet}
            currency={currency}
            gameMode={gameMode}
            sound={sound}
            music={music}
            volume={volume}
          />
        </BlurBox>
      </ScalingContainer>
      <Settings
        handleAbove={handleAbove}
        clickable={clickable}
        isAutoOn={isAutoOn}
        unBlur={unBlur}
        scaleDown={
          above === "History" || above === "provFair" || above === "gameRules"
        }
        display={displaySettings}
        handleClean={handleClean}
        h={intViewportHeight}
        sound={sound}
        music={music}
        volume={volume}
        // toggleMusic={toggleMusic}
        // toggleSound={toggleSound}
        handleVolume={handleVolume}
      />
      <HitsPage
        number={above && above.includes("Hits") ? above : null}
        unBlur={unBlur}
        bet={+bet}
        toFix={toFix}
        mode80={gameMode === "80"}
        coeficients={game_settings} //TODO
        handleAbove={handleAbove}
        display={displayHits}
        h={intViewportHeight}
        sound={sound}
        volume={volume}
      />
      <Autorules
        unBlur={unBlur}
        bet={betInfo.betAmount}
        isAutoOn={isAutoOn}
        handleAutoRollLogic={handleAutoRollLogic}
        handleAbove={handleAbove}
        userSettings={userSettings}
        handleNotification={handleNotification}
        gameState={gameState}
        toFix={toFix}
        display={displayAutoRules}
        currency={currency}
        h={intViewportHeight}
        scrollable={scrollable}
        opacity
        sound={sound}
        volume={volume}
      />
      {above === "provFair" && (
        <ProvFair
          handleAbove={handleAbove}
          isClickable={clickable}
          unBlur={unBlur}
          handleNotification={handleNotification}
          h={intViewportHeight}
          scrollable={scrollable}
          sound={sound}
          volume={volume}
        />
      )}
      {above === "SetBet" && (
        <SetBet
          handleAbove={handleAbove}
          unBlur={unBlur}
          handleNotification={handleNotification}
          toFix={toFix}
          minBet={gameState.minBet}
          maxBet={gameState.maxBet}
          currency={currency}
          h={intViewportHeight}
          scrollable={scrollable}
          opacity
          sound={sound}
          volume={volume}
          prec={gameState.afterDot}
        />
      )}

      {showGameRules && (
        <GameRules
          handleAbove={handleAbove}
          stats={stats}
          h={intViewportHeight}
          sound={sound}
          volume={volume}
          unBlur={unBlur}
        />
      )}

      <History
        history={history}
        stats={stats}
        handleAbove={handleAbove}
        gameState={gameState}
        toFix={toFix}
        display={showHistory}
        h={intViewportHeight}
        unBlur={unBlur}
        sound={sound}
        volume={volume}
        user_id={user_id}
        handleNotification={handleNotification}
      />
      {showBetReplay && (
        <BetReplay
          // history={history}
          // stats={stats}
          // gameState={gameState}
          // toFix={toFix}
          // display={showBetReplay}
          betReplyData={betReplyData}
          handleBetReply={handleBetReply}
          handleAbove={handleAbove}
          h={intViewportHeight}
          unBlur={unBlur}
          sound={sound}
          volume={volume}
          handleNotification={handleNotification}
          prec={gameState.afterDot}
        />
      )}
    </>
  );
};
export default memo(Keno);